export const LODESTAR_QUESTION_INPUT_TYPE = {
  CHECKBOX: 'checkbox',
  NUMBER: 'number',
  TEXT: 'text',
  SELECT: 'select',
};

export const LODESTAR_QUESTION_VALUE_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
};

export const LODESTAR_QUESTIONS_TITLE = 'LodeStar Questions';

export const LODESTAR_QUESTIONS_DESCRIPTION =
  'Review and update borrower answers used to calculate LodeStar fees.';

export const LODESTAR_QUESTIONS_SAVE_BUTTON_LABEL = 'Save';

export const LODESTAR_QUESTIONS_RESET_BUTTON_LABEL = 'Cancel changes';

export const LODESTAR_QUESTIONS_CONFIRMATION_MESSAGE = 'Recalculate fees with these answers?';

export const LODESTAR_QUESTIONS_CONFIRMATION_DESCRIPTION =
  'Saving these answers can change LodeStar-driven fees on this loan. ' +
  'You can recalculate the fees right away or save the answers without recalculating.';

export const LODESTAR_QUESTIONS_CONFIRMATION_ACCEPT_LABEL = 'Save and recalculate';

export const LODESTAR_QUESTIONS_CONFIRMATION_REJECT_LABEL = 'Save without recalculating';

export const LODESTAR_QUESTIONS_CONFIRMATION_CANCEL_LABEL = 'Cancel';
